import { Blockchains } from '@unifiprotocol/core-sdk'
import { subdomainsBlockchainsMap } from '../Config'

export const chainOnStorageKey = 'app.blockchain'

export const setChainOnStorage = (chain: Blockchains) =>
  localStorage.setItem('app.blockchain', chain)

export const getChainOnStorage = () => localStorage.getItem('app.blockchain') as Blockchains | null

export const isSubdomainChain = () => {
  const subdomain = window.location.hostname.split('.')[0]
  return !!subdomainsBlockchainsMap[subdomain]
}
